export default "__VITE_ASSET__BqrxOq21__"